import Modal from "react-bootstrap/Modal";
import {useContext, useRef, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import moment from "moment-timezone";
import "moment-timezone";

import AuthContext from "context/AuthContext";
import {SwalAlertClass} from "core/swalClass";
import axiApi from "ApiCaller";
import AssetBasic from "site-apps/assets/components/AssetBasic";
import {useTranslation} from "react-i18next";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";
import IconCardForLevel from "./IconCardForLevel";
import FormButton from "components/buttons/FormButton";

const ModalEditUnload = ({show, setShow, item, itemsShown, setItemsShown}) => {
    const {user, org} = useContext(AuthContext);
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});
    const formRef = useRef(null);
    const [isSubmit, setIsSubmit] = useState(false);

    const handleClose = () => {
        setShow(false);
    };

    const getHour = (item) => {
        if (!item || !item.time) return "";
        const dateTimeUTC = moment.utc(`${item.date}T${item.time}.000Z`);
        const dateTimeTZ = dateTimeUTC.tz(org?.timezone || "Europe/Madrid");
        return dateTimeTZ.format("HH:mm");
    };

    const handleSave = () => {
        setIsSubmit(true);
        let formData = new FormData(formRef.current);
        if (!formData.get("time")) {
            setShow(false);
            Alert.error(_TC("requiredTime")).then(() => setShow(true));
        }
        let DataSend = {
            uuid: item.item.uuid,
            exists: item.exists,
            last: {
                date: item.date,
                time: item.time,
                value: item.value,
            },
            new: {
                date: formData.get("date"),
                time: formData.get("time"),
                value: formData.get("value"),
            },
        };
        axiApi
            .post(`/api/unloads/update/`, DataSend)
            .then((resp) => {
                if (resp.data.status) {
                    const item_ = {...itemsShown[item.item.idx]};
                    if (DataSend.exists) {
                        item_.unloads[resp.data.unload.date] = item_.unloads[resp.data.unload.date].filter(
                            (u) => u.time !== DataSend.last.time,
                        );
                    }
                    const dated = resp.data.unload.date.split("-");
                    if (!(resp.data.unload.date in item_.unloads)) item_.unloads[resp.data.unload.date] = [];
                    item_.unloads[resp.data.unload.date].push({
                        date: `${dated[2]}-${dated[1]}-${dated[0]}`,
                        time: resp.data.unload.time,
                        value: resp.data.unload.value,
                        level: resp.data.unload.level,
                        timestamp: parseInt(resp.data.unload.timestamp),
                    });
                    const items_ = [...itemsShown];
                    items_[item.item.idx] = item_;
                    setShow(false);
                    Alert.success(_TC("unloadSuccess"));
                    setItemsShown([...items_]);
                } else {
                    setShow(false);
                    Alert.error(_TC("unloadError"));
                }
                setIsSubmit(false);
            })
            .catch((error) => {
                console.error(error);
                setIsSubmit(false);
            });
    };
    const handleDelete = () => {
        setIsSubmit(true);
        let formData = new FormData(formRef.current);
        if (!formData.get("time")) {
            setShow(false);
            Alert.error(_TC("requiredTime")).then(() => setShow(true));
        }
        let DataSend = {
            uuid: item.item.uuid,
            exists: item.exists,
            last: {
                date: item.date,
                time: item.time,
                value: item.value,
                timestamp: item.timestamp,
            },
        };
        axiApi
            .post(`/api/unloads/delete/`, DataSend)
            .then((resp) => {
                if (resp.data.status) {
                    Alert.success(_TC("unloadSuccess"));
                    const item_ = {...itemsShown[item.item.idx]};
                    item_.unloads[resp.data.unload.date] = item_.unloads[resp.data.unload.date].filter(
                        (u) => u.timestamp !== DataSend.last.timestamp,
                    );
                    if (item_.unloads[resp.data.unload.date].length === 0) delete item_.unloads[resp.data.unload.date];
                    const items_ = [...itemsShown];
                    items_[item.item.idx] = item_;
                    setShow(false);
                    setItemsShown([...items_]);
                } else {
                    Alert.error(_TC("unloadError"));
                }

                setIsSubmit(false);
            })
            .catch((error) => {
                setIsSubmit(false);
            });
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true} aria-modal={true} centered={true}>
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="truck-field" />
                    </div>
                    <div className="preview-title">
                        <Modal.Title className="d-inline">{_TC("unload")}</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <div className="col-12 d-flex justify-content-between">
                            <AssetBasic asset={item.item} />
                            <div className="card-unload-levels">
                                <IconCardForLevel level={item.level} />
                            </div>
                        </div>
                    </div>
                    <form className="row" ref={formRef}>
                        <div className="col-12 mb-3">
                            <div className="row d-flex justify-content-between">
                                <div className="col d-flex justify-content-end me-2">
                                    <div className="mt-3" style={{width: "120px"}}>
                                        <label htmlFor="modEdUn-date" className="form-label">
                                            {_TC("date")}
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control text-end"
                                            id="modEUn-date"
                                            name="date"
                                            defaultValue={item.date}
                                        />
                                    </div>
                                </div>
                                <div className="col d-flex justify-content-start ms-2">
                                    <div className="mt-3" style={{width: "100px"}}>
                                        <label htmlFor="modEdUn-time" className="form-label">
                                            {_TC("hour")}
                                        </label>
                                        <input
                                            type="time"
                                            className="form-control text-end"
                                            id="modEUn-time"
                                            name="time"
                                            defaultValue={getHour(item)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 d-flex justify-content-center mb-3">
                            <div className="mt-3 text-center" style={{width: "80px"}}>
                                <label htmlFor="modEdUn-value" className="form-label">
                                    {_TC("filling")}
                                </label>
                                <input
                                    type="number"
                                    className="form-control text-end"
                                    id="modEUn-value"
                                    name="value"
                                    defaultValue={item.value}
                                />
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-12">
                        <div className="row d-flex justify-content-between">
                            <div className="col">
                                {user.is_admin && item.exists && (
                                    <FormButton
                                        type="button"
                                        className="btn btn-danger ms-2"
                                        isProcessing={isSubmit}
                                        onClick={handleDelete}>
                                        {_Tf("labels.delete")}
                                    </FormButton>
                                )}
                            </div>
                            <div className="col text-end">
                                <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                    {_Tf("labels.close")}
                                </button>
                                {user.is_admin ? (
                                    <FormButton
                                        type="button"
                                        className="btn btn-primary ms-3"
                                        isProcessing={isSubmit}
                                        onClick={handleSave}>
                                        {_Tf("labels.save")}
                                    </FormButton>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalEditUnload;
